import React, { Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { deleteItem, deleteMultipleItem, postfetchData, toggleStatus } from "../../../utils/apiUtils";
import getFileType, {checkImage, ColumnAdjust, DeleteButton, PlusButton, ToggleSwitch } from "../../../helper/ImageFormat";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { ImageLink } from "../../../utils/constants";
import Breadcrumb from "../../../helper/Breadcrumb";
import DeleteModel, { confirmBulkDelete } from "../../../Components/DeleteModel";
import ProductTable from "./ProductTable";
import { cdnInstance } from "../../../axiosInterceptor";
import { productColumnsList } from "../../../Data/columnsData";
import ColumnVisibilitySidebar from "../../../Components/ColumnVisibilitySidebar";
import PerPageSelect from "../../../Components/PerPageSelect";
import TableSearch from "../../../Components/TableSearch";
import BackButton from "../../../Components/BackButton";

const Products = () => {
  const { id } = useParams();
  const navigator = useNavigate();
  const location = useLocation();
  const editdata = location.state;
  const [loading, setLoading] = useState(true);
  const [productData, setproductData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [IsDeleting, setIsDeleting] = useState(false)
  const totalPages = Math.ceil(totalCount / perPage);
  const [selected, setSelected] = useState([]);
   const [sidebarOpen, setSidebarOpen] = useState(false);
const [columnsList, setColumnsList] = useState(productColumnsList);

  const fetchProductData = async (page = 1, searchQuery, filter) => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
      category_id: id,
      type:"",
      searchQuery,
      brandId: filter?.brandId,
      attributeValue: filter?.attributeValue,
      name: filter?.name,
      sku: filter?.sku
    };
    await postfetchData(
      "product-pagination",
      requestData,
      setproductData,
      setTotalCount,
      setCurrentPage,
      setLoading
    );
  };

  useEffect(() => {
    const delay = search ? 500 : 0;

    const handler = setTimeout(() => {
      fetchProductData(currentPage, search);
    }, delay);

    return () => clearTimeout(handler);
  }, [search, perPage]);

   const handleToggleColumn = (key) => {
  setColumnsList((prev) =>
    prev.map((col) =>
      col.key === key ? { ...col, visible: !col.visible } : col
    )
  );
};

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchProductData(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("product", deleteItemId?.id, fetchProductData);
      if (res && deleteItemId?.image && deleteItemId?.mediumImage && deleteItemId?.thumbImage) {
        const imagesToDelete = deleteItemId.image.map((imgPath, i) => ({
          original: imgPath,
          mediumImage: deleteItemId.mediumImage[i],
          thumbImage: deleteItemId.thumbImage[i],
        }));

        await Promise.all(
          imagesToDelete.map(async (imgToDelete) => {
            await cdnInstance.delete("/delete-product", { data: imgToDelete });
          })
        );
      }

      setDeleteItemId({});
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };




  const handleStatusToggle = async (productdata) => {
    const data = await toggleStatus("product-status", productdata?.id);
    if (Object.keys(data).length > 0) {
      setproductData((prevdata) => {
        if (!prevdata?.data?.length) return prevdata;

        return {
          ...prevdata,
          data: prevdata.data.map((item) =>
            item.id === data.id ? { ...item, isActive: data.isActive } : item
          ),
        };
      });

    }
  };

  const handleFancyBox = (images) => {
    Fancybox.show(
      images
        .filter((img) => getFileType(img) === "image")
        .map((img) => ({
          src: ImageLink(img),
          type: "image",
        })),
      {
        Thumbs: {
          autoStart: true,
        },
      }
    );
  };

  const handleEditClick = (data) => {
    navigator(`/add-products/${id}`, {
      state: { updateId: data?.id },
    });
  };

  const handleAdd = () => {
    navigator(`/add-products/${id}`, {
      state: editdata,
    });
  };

  const handleRedirect = (id) => {
    navigator(`/product-detail/${id}`);
  };

 

  const handlebulkDelete = async () => {
    await confirmBulkDelete({
      itemType: "Products",
      selectedIds: selected,
      deleteApiCall: (ids) => deleteMultipleItem("product-bulk-delete", ids),
      refreshCallback: fetchProductData,
    });
  };
  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Category", path: "/category" },
    { label: "products", path: "/catretail-product" },
  ];




  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mt-5">
          <h3 className="custom-page-title">Products</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>

      


        <div
          className="d-flex justify-content-between mb-1"
          style={{ background: "#fff", padding: "10px" }}
        >
         <PerPageSelect value={perPage} onChange={setPerPage}/>

          <div style={{ display: "flex", gap: "20px" }}>
            <BackButton to={"/category"}/>
            <TableSearch value={search} onChange={setSearch} />

{/* <Back handleBack={()=> navigator("/category")}/> */}
            {/* <HandAdvancefilter handleAdd={handlefilter} /> */}
            <PlusButton handleAdd={handleAdd} module={"Products"} />
            <ColumnAdjust handleOpen={() => setSidebarOpen(true)} />
            {selected && selected?.length > 0 && (
              <DeleteButton
                handleAdd={handlebulkDelete}
                name="Selected Products"
                module={"Products"}
              />
            )}
          </div>
        </div>

        <ProductTable
          loading={loading}
          productData={productData}
          currentPage={currentPage}
          perPage={perPage}
          handleEditClick={handleEditClick}
          handleDelete={handleDelete}
          handleStatusToggle={handleStatusToggle}
          totalCount={totalCount}
          totalPages={totalPages}
          handlePageClick={handlePageClick}
          handleFancyBox={handleFancyBox}
          checkImage={checkImage}
          ToggleSwitch={ToggleSwitch}
          handleRedirect={handleRedirect}
          selected={selected}
          setSelected={setSelected}
           columnsList={columnsList}
        />
      </div>

      {modalOpen && (
        <Suspense fallback={<div>Loading...</div>}>
          <DeleteModel
            deleteModalOpen={modalOpen}
            setDeleteModalOpen={() => setModalOpen(!modalOpen)}
            onConfirm={confirmDelete}
            itemName="Products"
            isDeleting={IsDeleting}
          />
        </Suspense>
      )}

       {sidebarOpen && (
                  <ColumnVisibilitySidebar
                  columns={columnsList}
                  onToggle={handleToggleColumn}
                  onClose={() => setSidebarOpen(false)}
                  />
              )}
    </>
  );
};

export default Products;
